import { Component, EventEmitter, inject, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AiService } from '../../../../service/ai.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SnackService } from '../../../../service/snack.service';
import { DisclaimerTypes } from '../../../../interfaces/disclaimertypes';

@Component({
    selector: 'app-webresearch',
    standalone: false,
    templateUrl: './webresearch.component.html',
    styleUrl: './webresearch.component.scss'
})
export class WebresearchComponent {
    // Injections
    aiService = inject(AiService);
    dialog = inject(MatDialogRef<WebresearchComponent>);
    snack = inject(SnackService);
    data: { title: string, source: string, description: string }[] = inject(MAT_DIALOG_DATA);

    maxWebSearches: number = 0;
    leftSearches: number = 0;
    disclaimerType: DisclaimerTypes = DisclaimerTypes.EXTERNAL_RISK

    selectedQuestion: { title: string, source: string, description: string }[] = []

    constructor() {
        console.log("Questionnnnnnsss", this.data);

    }

    toggleSearch(search: { title: string, source: string, description: string }) {
        if (this.selectedQuestion.includes(search)) {
            this.selectedQuestion = this.selectedQuestion.filter(q => q !== search);
            return;
        }

        this.selectedQuestion.push(search);
    }

    close() {
        this.dialog.close();
    }

    run() {
        this.dialog.close(this.selectedQuestion);
    }

}
